import React from 'react';
import { Button, Tooltip } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { SortInfoModel } from '../../../Models/applicationModels';
import { SORT_ICON_COLORS } from './sortIcons.constant';
import { getSortApiField } from './sortIcon.utils';
import styles from './sortIcons.module.css';

interface SortIconsProps {
  column: string;
  sortColumn?: string;
  sortDescending?: boolean;
  handleChangeSort: (sortItem: SortInfoModel | null) => Promise<void>;
}

const CustomSortIcons: React.FC<SortIconsProps> = ({ sortColumn = '', column, sortDescending = true, handleChangeSort }) => {
  const sortApiField = getSortApiField(column);
  const isActive = sortColumn === sortApiField;
  const isSameSort = (direction: boolean) =>
    isActive && sortDescending === direction;


  const handleClick = (sortDesc: boolean) => {
    if (isSameSort(sortDesc)) {
      handleChangeSort(null);
    } else {
      handleChangeSort({
        value: sortApiField,
        sortDescending: sortDesc,
      });
    }
  };

  const ascendingActive = isSameSort(false);
  const descendingActive = isSameSort(true);

  return (
    <div className={styles.sortIconsContainer}>
      <Tooltip
        title="Sort Ascending order"
        styles={{ root: { fontSize: '12px'} }}
      >
        <Button
          variant="text"
          className={styles.sortIconButton}
          ghost={true}
          icon={
            <CaretUpOutlined
              style={{
                color: ascendingActive ? SORT_ICON_COLORS.active : SORT_ICON_COLORS.inactive
              }}
              className={styles.sortIcon}
            />
          }
          size="small"
          onClick={() => handleClick(false)}
        />
      </Tooltip>
      <Tooltip
        title="Sort Descending order"
        styles={{ root: { fontSize: '12px' } }}
        >
        <Button
          variant="text"
          ghost={true}
          icon={
            <CaretDownOutlined
              style={{
                color: descendingActive ? SORT_ICON_COLORS.active : SORT_ICON_COLORS.inactive,
              }}
              className={styles.sortIcon}
            />
          }
          size="small"
          className={styles.sortIconButton}
          onClick={() => handleClick(true)}
        />
      </Tooltip>
    </div>
  );
};

export default CustomSortIcons;
